<script>
import baseMixin from '@/mixins/baseMixin'
import { FormField } from '@/models/forms/fields/formField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionDefaultField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: FormField,
      required: true,
    },
    value: {
      required: true,
      type: null,
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <span
        class="text-body-2 my-4 pa-4 lh-175 rounded-lg"
        :class="{ 'field-response': value }"
        >{{ value }}</span
      >
    </InfoLabel>
  </div>
</template>

<style lang="scss" scoped>
.field-response {
  background: rgba(156, 156, 156, 0.1) !important;
}
</style>
